import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const AIRCRAFT_IMG = '/images/hxd-subscribe-aircraft.png';

export default function SubscribeBanner() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');

  const onSubmit = (e) => {
    e.preventDefault();
    const trimmed = email.trim();
    const q = trimmed ? `?email=${encodeURIComponent(trimmed)}` : '';
    navigate(`/signup${q}`);
  };

  return (
    <section
      className="w-full bg-[#0A0A0A] text-white border-b-4 border-[#0A0A0A]"
      aria-labelledby="subscribe-banner-heading"
    >
      <div className="max-w-page mx-auto flex flex-col sm:flex-row sm:items-center sm:min-h-[200px]">
        <div className="flex-1 min-w-0 flex flex-col justify-center px-5 sm:px-6 py-5 sm:py-4">
          <h2
            id="subscribe-banner-heading"
            className="font-serif text-[clamp(1.125rem,2.5vw,1.5rem)] font-bold leading-[1.2] tracking-[-0.02em] m-0"
          >
            Become sharper on aviation &amp; AAM in 5 minutes
          </h2>
          <p className="mt-2 text-[13px] leading-[1.45] text-white/80 max-w-md">
            Editor-curated eVTOL, defense aviation, and AAM intelligence — weekday mornings.
          </p>

          <form
            onSubmit={onSubmit}
            className="mt-3 flex flex-col sm:flex-row sm:items-stretch gap-2 max-w-md w-full"
            noValidate
          >
            <label htmlFor="subscribe-banner-email" className="sr-only">
              Email address
            </label>
            <input
              id="subscribe-banner-email"
              type="email"
              autoComplete="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="flex-1 min-w-0 rounded-md border-0 px-3 py-2 text-[14px] text-[#0A0A0A] placeholder:text-[#737373] focus:outline-none focus:ring-2 focus:ring-[#e87722]"
            />
            <button
              type="submit"
              className="shrink-0 rounded-md bg-white px-5 py-2 text-[12px] font-bold tracking-[0.08em] uppercase text-[#0A0A0A] transition-opacity hover:opacity-90 sm:w-auto w-full"
            >
              Subscribe
            </button>
          </form>

          <p className="mt-2 text-[10px] leading-snug text-white/55 max-w-md">
            By subscribing, you accept our{' '}
            <Link to="/signup" className="underline hover:text-white/90">
              account terms
            </Link>
            . Unsubscribe anytime.
          </p>
        </div>

        <div className="flex shrink-0 items-center justify-center sm:justify-end px-5 pb-5 sm:px-6 sm:py-4 border-t sm:border-t-0">
          <img
            src={AIRCRAFT_IMG}
            alt="Hangar X Studios"
            width={744}
            height={484}
            className="h-[140px] sm:h-[180px] w-auto max-w-[min(100%,300px)] sm:max-w-[280px] object-contain object-center"
          />
        </div>
      </div>
    </section>
  );
}
